"use client";
import cn from "clsx";
import BlogCard from "@molecules/BlogCard";

import { useRouter, useSearchParams, usePathname } from 'next/navigation'
import { useRef } from "react";

import Link from "next/link";

import { TAGS, CATEGORY, getYearListArray, getKeyByURL } from "./utils";
import { PaginationSection } from "../PageSection/PaginationSection";


import styles from "./styles.module.scss";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";

const TILE_SIZE = 12;

const sliceBlogs = ({ itemLength }) => {
  return Math.trunc(itemLength / TILE_SIZE) + (itemLength % TILE_SIZE == 0 ? 0 : 1);
};

export default function BlogsListSection({ blogs, isDesktop, currentPageNumber, slug, blogLength, title, exploreBlogTitle = "" }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const router = useRouter();

  const blogsCardRef = useRef(null);

  const pageLength = sliceBlogs({ itemLength: blogLength });

  const appendParams = (url: string, params: URLSearchParams) =>  params.toString().length ? url +"?" + params.toString() : url;
  
  const onChangeDropdown = (e) => {
    const { value } = e.target;
    pushToDataLayer({
      event: "filter_section_interaction",
      cta_text: value || "NA",
      action: "select",
      category: "Filter by",
      option_selected: value || "NA",
      section_name: exploreBlogTitle || "NA",
      page_type: getGlobalStateValue('pageType'),
    });
    if(value === "all"){
      router.replace('/blog')
    } else {
      router.replace('/blog/category/' + value)
    }
  }

  const changeAppliedFilter = (filterType: string, filterValue: string) => {
   
    const params = new URLSearchParams(searchParams.toString())

    if (filterType === "year" && filterValue === "all") {
      params.delete("year");
    } else if (filterType === "tag" && TAGS[filterValue] === "all") {
      params.delete("tag");
    } else {
      params.set(filterType, filterValue);
    } 
    
    if(currentPageNumber == 1){
      router.push(appendParams(pathname, params ));
    } else if(slug == 'all') {
      router.replace(appendParams("/blog", params ));
    } else{
      router.replace(appendParams("/blog/category/" + slug, params ));
    }
   
  };
  const fireWebEngage=(source:any)=>{
    window.webengage.track("Filter Blog", {
      "Type":source,
      "Year":source
    })
  }
  const firingWebEngage=(source:any)=>{
    window.webengage.track("Blog Menu Clicked", {
      "Menu":source,
    })
  }

  return (
    <div className={styles.container}>
      {isDesktop ? (
        <ul className={styles.departments}>
          {Object.keys(CATEGORY).map((category) => (
            <li
              key={category}
              className={cn({
                [styles.selectedLink]: slug === CATEGORY[category].value,
              })}
            >
              <Link
                href={
                  category.toLocaleLowerCase() === "all"
                    ? "/blog"
                    : `/blog/category/${CATEGORY[category].value}`
                }
                onClick={()=>firingWebEngage(category)}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
      <div className={styles.filterContainer}>
        <div className={styles.root}>
          <span>Filter by : </span>

          {!isDesktop && 
            <select value={CATEGORY[getKeyByURL(slug)].value} onChange={onChangeDropdown}>
              {Object.keys(CATEGORY).map((item, i) => (
                <option key={i} value={CATEGORY[item].value}>
                {item}
                </option>
              ))}
            </select>
          }

            <select value={searchParams.get('tag') || TAGS['All']} onChange={(e)=> {
              pushToDataLayer({
                event: "filter_section_interaction",
                cta_text: e.target.value || "NA",
                action: "select",
                category: "Filter by tag",
                option_selected: e.target.value || "NA",
                section_name: exploreBlogTitle || "NA",
                page_type: getGlobalStateValue('pageType'),
              });
              changeAppliedFilter("tag", e.target.value)
              fireWebEngage(e.target.value);
            }}>
              {Object.keys(TAGS).map((item, i) => (
                <option key={i} value={item}>
                {TAGS[item]}
                </option>
              ))}
            </select>
        
          <select 
           value={searchParams.get('year') || 'all'}  onChange={(e) => {
            pushToDataLayer({
              event: "filter_section_interaction",
              cta_text: e.target.value || "NA",
              action: "select",
              category: "Filter by year",
              option_selected: e.target.value || "NA",
              section_name: exploreBlogTitle || "NA",
              page_type: getGlobalStateValue('pageType'),
            });
            changeAppliedFilter("year", e.target.value)
            fireWebEngage(e.target.value);
          }}>
            {getYearListArray().map((year, i) => (
              <option  key={i} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <p className={styles.count}>Showing {blogLength} results</p>
      </div>
      {/* Need to show "No Blogs Found" if there is no filterdBlogs are available for current filters */}
      {blogs?.length > 0 ? (
        <div className={styles.cardsContainer} ref={blogsCardRef}>
          {blogs
            ?.map((blog, i) => (
              <BlogCard key={i} {...blog.attributes} isBlogList title={title} />
            ))}
        </div>
      ) : (
        <p className="text-primary-blue text-xl lg:text-2xl text-center mt-12 lg:mt-18">
          No Blogs Found!
        </p>
      )}

      <PaginationSection
        slug={slug == "all" ? null : slug}
        pageLength={pageLength}
        currentPageNumber={currentPageNumber}
      />
    </div>
  );
}
